function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { StatusCodes } from 'http-status-codes';
import { createEntityDataReceivedAction, createSearchboxInputChangedAction, createEntityDetailsReceivedAction, createAppDetailPricingReceivedAction, setBillingRegionAction, createUserSignOutAction, createUserProfileAction, createUserSignInFetchStatusAction, createUpdateUserProfileAction, createClearUserPropertiesAction, createDynamicCampaignReceivedAction, createSetTenantTypeAction, createServicesCountriesDataReceivedAction, createDataMapReceivedAction, createFilteredSearchResultsReceivedAction, createRelatedAppsItemsReceivedAction, createRelatedAppsItemsLoadingAction, createSetEntityIdLoadingAction, createSetEntityIdFailedAction, createGetAppReviewsAction, createUserTenantsDetailsAction, createUserTenantsDetailsLoadingAction, createUserProfileLoadingAction, createPartnerSearchResultsReceivedAction, createEntityReviewCommentsReceivedAction, createEntityReviewCommentsCleanupAction, createEntityReviewCommentCreateResult, createEntityReviewCommentDeleteResult, createEntityReviewCommentUpdateResult, createEntityReviewCommentModalAction, createUserLoginDetailsAction, createEntityReviewCommentsLoadingAction, createEntityReviewCommentsInitializeStateAction, createEntityReviewCommentsUpdateTotalCommentCountAction, createEntityMarkedAsHelpfulReviewUpdateListAction, createEntityLinkedInProductGroupUpdateAction, createEntityReviewMarkAsHelpfulModalAction, createEntityReviewSetIsHelpfulAction, createEntityReviewSetMarkAsHelpfulCount, createEntityReviewSetIsHelpfulLoadingAction, createSetStorefrontNameAction, createEntityUserCommentedReviewIdsUpdateListAction, createShowingResultsForReceivedAction, createUpdateUserRoleDefinitions, createSetAccountIsLoadingAction, createSetAccountAction, createAppsPricingDataResetAction, createPrivateEntityFullDataReceivedAction, createPrivateAppsPricingDataReceivedAction, createFeaturedAppsReceivedAction } from '@shared/actions/actions';
import { createUpdateCustomerAction, createSetActiveCustomerAction, createSetPublisherTokenResponse, createSetCustomersAction, createErrorAction, createClearErrorAction, createProduct, createFetchingProductAction } from '@shared/actions/checkoutActions';
import { isOnMicrosoftEmail, shouldEnsureAppDetails, shouldEnsureAppRelatedApps, shouldEnsureAppPricings, shouldEnsureServiceDetails, shouldEnsureServiceRelatedApps, shouldEnsureAppReviews, getTileDataQueryParams, getActiveFeaturedFlags, getProductByUrlKey, generateGuid, getTileDataCuratedQueryParams, getTileDataFilteredQueryParams, shouldEnsurePrivateAppPricings, shouldEnsurePrivateAppDetails } from '@shared/utils/appUtils';
import { createLeadPayload, scrubLeadPayload } from '@shared/utils/leadsUtils';
import { dispatchSearchQueryChangedAction, takeTopResults } from '@shared/utils/thunkActionUtils';
import * as suggestionsRestClient from '@shared/services/http/suggestionsRestClient';
import * as catalogApiRestClient from '@shared/services/http/catalogApiRestClient';
import * as armRestClient from '@shared/services/http/armRestClient';
import * as entityRestClient from '@shared/services/http/entityRestClient';
import * as leadgenRestClient from '@shared/services/http/leadgenRestClient';
import * as reviewRestClient from '@shared/services/http/reviewRestClient';
import * as fieldHubRestClient from '@shared/services/http/fieldHubRestClient';
import * as userRestClient from '@shared/services/http/userRestClient';
import * as dynamicCampaignRestClient from '@shared/services/http/dynamicCampaignRestClient';
import * as purchaseRestClient from '@shared/services/http/purchaseRestClient';
import * as commerceApiRestClient from '@shared/services/http/commerceApiRestClient';
import * as appReviewCommentsRestClient from '@shared/services/http/reviewCommentsRestClient';
import * as appReviewMarkAsHelpfulRestClient from '@shared/services/http/reviewMarkAsHelpfulRestClient';
import * as reviewsCatalogRestClient from '@shared/services/http/reviewsCatalogRestClient';
import * as linkedInRestClient from '@shared/services/http/linkedInRestClient';
import * as graphRestClient from '@shared/services/http/graphRestClient';
import * as reportReviewRestClient from '@shared/services/http/reportReviewRestClient';
import * as reviewAppReviewsRestClient from '@shared/services/http/reviewAppReviewsRestClient';
import * as userReviewRestClient from '@shared/services/http/userReviewRestClient';
// Constant API version that maps to the app schema,
// inflight browser never calls the API directly hence this is the only place the version lives
import { getCookieItem, saveCookieItem } from '@shared/utils/browserStorageUtils';
import { Constants } from '@shared/utils/constants';
import { getWindow } from '@shared/services/window';
import { UserSegment, CustomerType } from '@shared/Models';
import { SharedInstrumentService } from '@shared/services/telemetry/shared/sharedInstrument';
import { AzureEnvironmentSettings } from '@shared/AzureEnvironmentSettings';
import * as authRestClient from '@shared/services/http/authRestClient';
import { shouldRefreshToken, logError } from '@shared/utils/httpClientUtil';
import { previousPage, routes } from '@shared/routerHistory';
import { getCampaignsForAcquisitionFromUrl } from '@shared/utils/routeUtils';
import { getSearchQuery, removeDuplicateAddIns } from '@shared/utils/search';
import { stringifyError } from '@shared/utils/errorUtils';
import { extractCountryCodeFromQueryParam } from '@shared/utils/consultingServicesUtils';
import { ensurePrivateOffer } from './privateOffersThunkActions';
import { Product } from 'services/product/product';
import { logger } from '@src/logger';
import { launchTelemetry as launchReviewsTelemetry } from '@shared/utils/reviewsUtils';
import { request } from '@shared/utils/requestUtils';
import { HttpModule } from '@shared/services/http/httpProtocol';
import { fetchUserFavourites } from './userFavouriteThunkActions';
import { BillingAccountType, BillingAgreementType } from '@src/interfaces/IBilling';
import { fetchPricingAction } from '@shared/utils/pricingThunkActionUtils';
let tilesViewService;
let servicesViewService;
let cloudsIndustryViewService;
let detailsViewService;
let servicesDetailsViewService;
let pricingViewService;
let productDetailsViewService;
let featuredAppsService;
if (__SERVER__) {
    tilesViewService = require('@src/server/viewAPIServices/tilesViewService');
    servicesViewService = require('@src/server/viewAPIServices/servicesViewService');
    cloudsIndustryViewService = require('@src/server/viewAPIServices/cloudsIndustryViewService');
    detailsViewService = require('@src/server/viewAPIServices/detailsViewService');
    servicesDetailsViewService = require('@src/server/viewAPIServices/servicesDetailsViewService');
    pricingViewService = require('@src/server/viewAPIServices/pricingViewService');
    productDetailsViewService = require('@src/server/viewAPIServices/productDetailsViewService');
    featuredAppsService = require('@src/server/viewAPIServices/featuredAppsService');
}
// eslint-disable-next-line @typescript-eslint/ban-types
export function telemtry(action, actionModifier, details) {
    const payload = {
        page: getWindow() && getWindow().location && getWindow().location.href,
        action,
        actionModifier,
        details: JSON.stringify(details)
    };
    logger.info(payload.details, {
        action: payload.action,
        actionModifier: payload.actionModifier
    });
}
function mockRequest({ state, query = {}, request: req = {} }) {
    return request({
        correlationId: state.config.correlationId,
        requestId: state.config.requestId,
        context: _object_spread({}, req.context),
        query: _object_spread_props(_object_spread({}, query), {
            [Constants.QueryStrings.flightCodes]: state.config.flightCodes,
            [Constants.QueryStrings.isConverged]: state.config.isConverged ? 'true' : 'false'
        })
    });
}
export function ensureAppsDataMap() {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            var _getProductByUrlKey;
            if (getState().apps.dataMapLoaded) {
                return Promise.resolve();
            }
            const embedHost = (_getProductByUrlKey = getProductByUrlKey({
                urlKey: getState().config.embedHost
            })) === null || _getProductByUrlKey === void 0 ? void 0 : _getProductByUrlKey.UrlKey;
            let dataMap$;
            if (__CLIENT__) {
                dataMap$ = entityRestClient.getAppsDataMap({
                    embedHost
                });
            } else {
                dataMap$ = tilesViewService.getAppsDataMap({
                    request: mockRequest({
                        state: getState()
                    }),
                    embedHost
                });
            }
            const dataMap = yield dataMap$;
            dispatch(createDataMapReceivedAction({
                entityType: Constants.EntityType.App,
                dataMap
            }));
            return dataMap;
        })();
    };
}
export function ensureCloudsIndustryDataMap() {
    return function(dispatch, getState) {
        if (getState().cloudsIndustry.dataMapLoaded) {
            return Promise.resolve();
        }
        let dataMap$;
        if (__CLIENT__) {
            dataMap$ = entityRestClient.getCloudsIndustryDataMap();
        } else {
            dataMap$ = cloudsIndustryViewService.getCloudsIndustryDataMap({
                request: mockRequest({
                    state: getState()
                })
            });
        }
        return dataMap$.then((dataMap)=>{
            dispatch(createDataMapReceivedAction({
                entityType: Constants.EntityType.CloudsIndustry,
                dataMap
            }));
            return dataMap;
        });
    };
}
export function ensureServicesDataMap() {
    return function(dispatch, getState) {
        if (getState().services.dataMapLoaded) {
            return Promise.resolve();
        }
        let dataMap$;
        if (__CLIENT__) {
            dataMap$ = entityRestClient.getServicesDataMap();
        } else {
            dataMap$ = servicesViewService.getServicesDataMap({
                request: mockRequest({
                    state: getState()
                })
            });
        }
        return dataMap$.then((dataMap)=>{
            dispatch(createDataMapReceivedAction({
                entityType: Constants.EntityType.Service,
                dataMap
            }));
            return dataMap;
        });
    };
}
export function ensureServiceData({ request }) {
    return function(dispatch, getState) {
        const state = getState();
        const { search: { previousSearchText }, config: { includeTestProducts, isConverged } } = state;
        const options = {
            includeTestProducts,
            isConverged
        };
        const requestId = request.headers[Constants.Headers.RequestId] || '';
        const userSegment = Constants.ServicesUserSegment;
        if (state.services.dataLoaded[`${userSegment}`]) {
            return Promise.resolve();
        }
        const urlQuery = _object_spread({}, getTileDataQueryParams(state.config.query), getActiveFeaturedFlags(state.config.featureFlags));
        let getFilteredServices$;
        if (__CLIENT__) {
            getFilteredServices$ = entityRestClient.getFilteredServices({
                urlQuery,
                requestId,
                options
            });
        } else {
            getFilteredServices$ = servicesViewService.getFilteredServices({
                request: mockRequest({
                    state: getState(),
                    query: urlQuery,
                    request
                }),
                options
            });
        }
        return getFilteredServices$.then((result)=>{
            const { items, count, showingResultsFor = '' } = result;
            dispatch(createEntityDataReceivedAction({
                entityType: Constants.EntityType.Service,
                dataList: items,
                isEmbedded: state.config.isEmbedded,
                userSegment: Constants.ServicesUserSegment,
                count,
                urlQuery
            }));
            // This is to ensure we don't accidently reset the showing results for due to the 3 searches we're doing: Apps, Consulting Services, Industry Clouds
            if (urlQuery.search !== previousSearchText && showingResultsFor.length > 0) {
                dispatch(createShowingResultsForReceivedAction({
                    showingResultsFor,
                    previousSearchText: urlQuery.search
                }));
            }
            return result;
        });
    };
}
export function ensureServiceCountries() {
    return function(dispatch, getState) {
        let countryDate = Promise.resolve();
        if (!Object.keys(getState().services.countriesList).length && getState().config.isAppSource) {
            countryDate = new Promise((resolve, reject)=>{
                servicesViewService.getAllServicesCountries({
                    request: mockRequest({
                        state: getState()
                    })
                }).then((countries)=>{
                    dispatch(createServicesCountriesDataReceivedAction({
                        countries
                    }));
                    resolve();
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        return countryDate;
    };
}
export function getUserAuthStatus() {
    return function(dispatch, getState) {
        return new Promise((resolve, reject)=>{
            const state = getState();
            if (state.config.embedHost) {
                return resolve(Constants.SigninStatus.ValidationSkipped);
            }
            if (state.users.accessToken && !shouldRefreshToken(state.users.accessToken.spza)) {
                // The token is still valid and not nearing expiry dont make a server call, let the flow continue.
                resolve(Constants.SigninStatus.ValidTokenUnknownCookie);
            } else {
                authRestClient.getUserAuthStatus().then((result)=>{
                    // the token has expired and cookie is guest sign the user out from state
                    if (result.status === Constants.SigninStatus.ExpiredTokenInvalidCookie) {
                        dispatch(createUserSignOutAction(null));
                    }
                    resolve(result);
                }).catch((error)=>{
                    reject(error);
                });
            }
        });
    };
}
export function getAppReviews(entityId) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const { config: { reviewsAPI, reviewsAPIVersion, storefrontName, isConverged }, users: { signedIn } } = getState();
            const source = isConverged ? Constants.StorefrontName.Marketplace : storefrontName;
            const reviews$ = reviewAppReviewsRestClient.getAppReviews({
                entityId,
                reviewsAPI,
                reviewsAPIVersion
            });
            const isPurchased$ = signedIn && reviewRestClient.getPurchaseStatus(entityId);
            const userReview$ = signedIn && userReviewRestClient.get({
                offerId: entityId,
                reviewsAPI,
                reviewsAPIVersion,
                source
            }) || Promise.resolve([]);
            const [reviews, isPurchased, [userReview]] = yield Promise.all([
                reviews$,
                isPurchased$,
                userReview$
            ]);
            return dispatch(createGetAppReviewsAction({
                entityId,
                reviews,
                isPurchased,
                userReview
            }));
        })();
    };
}
export function ensureAppReviewsData(entityId, forceUpdate = false) {
    return function(dispatch, getState) {
        if (!entityId) {
            return Promise.resolve(false);
        }
        const start = Date.now();
        if (shouldEnsureAppReviews(entityId, getState()) || forceUpdate) {
            return Promise.resolve(dispatch(getAppReviews(entityId))).catch((error)=>{
                const payload = {
                    page: getWindow() && getWindow().location.href,
                    action: Constants.Telemetry.Action.EnsureAppReviewsData,
                    actionModifier: Constants.Telemetry.ActionModifier.Error,
                    details: JSON.stringify({
                        duration: Date.now() - start,
                        error: stringifyError(error)
                    })
                };
                logger.error(payload.details, {
                    action: payload.action,
                    actionModifier: payload.actionModifier
                });
                return false;
            });
        }
        return Promise.resolve(true);
    };
}
export function ensureAppData({ billingRegion, request }) {
    return function(dispatch, getState) {
        var _getProductByUrlKey;
        const state = getState();
        const { search: { previousSearchText }, config: { isEmbedded } } = state;
        const requestId = request.headers[Constants.Headers.RequestId] || '';
        const userSegment = UserSegment[UserSegment.unauthenticated];
        if (state.apps.dataLoaded[`${userSegment}`]) {
            return Promise.resolve();
        }
        const { flightCodes, includeTestProducts, isConverged } = state.config;
        const urlQuery = _object_spread({}, getTileDataQueryParams(state.config.query), getActiveFeaturedFlags(state.config.featureFlags));
        const embedHost = (_getProductByUrlKey = getProductByUrlKey({
            urlKey: state.config.embedHost
        })) === null || _getProductByUrlKey === void 0 ? void 0 : _getProductByUrlKey.UrlKey;
        const tileDataCuratedQueryParams = getTileDataCuratedQueryParams(state.config.query);
        const tileDataFilteredQueryParams = getTileDataFilteredQueryParams(state.config.query);
        const isCurating = Object.keys(tileDataFilteredQueryParams).length > 0 || Object.keys(tileDataCuratedQueryParams).length > 0;
        const options = {
            includeTestProducts,
            isConverged,
            optimizeSorting: !isCurating && !isEmbedded
        };
        let getFilteredApps$;
        if (__CLIENT__) {
            getFilteredApps$ = entityRestClient.getFilteredApps({
                billingRegion,
                flightCodes,
                embedHost,
                urlQuery,
                requestId,
                options
            });
        } else {
            getFilteredApps$ = tilesViewService.getFilteredApps({
                request: mockRequest({
                    state: getState(),
                    query: urlQuery,
                    request
                }),
                billingRegion,
                flightCodes,
                embedHost,
                options
            });
        }
        return getFilteredApps$.then((result)=>{
            const { items, count, showingResultsFor = '' } = result;
            dispatch(createEntityDataReceivedAction({
                entityType: Constants.EntityType.App,
                dataList: items,
                isEmbedded: state.config.isEmbedded,
                userSegment,
                count,
                urlQuery
            }));
            // This is to ensure we don't accidently reset the showing results for due to the 3 searches we're doing: Apps, Consulting Services, Industry Clouds
            if (urlQuery.search !== previousSearchText && showingResultsFor.length > 0) {
                dispatch(createShowingResultsForReceivedAction({
                    showingResultsFor,
                    previousSearchText: urlQuery.search
                }));
            }
            return result;
        });
    };
}
export function ensureCloudsIndustryData({ request }) {
    return function(dispatch, getState) {
        const state = getState();
        const { search: { previousSearchText } } = state;
        const requestId = request.headers[Constants.Headers.RequestId] || '';
        const userSegment = UserSegment[UserSegment.unauthenticated];
        if (state.apps.dataLoaded[`${userSegment}`]) {
            return Promise.resolve();
        }
        const urlQuery = _object_spread_props(_object_spread({}, getTileDataQueryParams(state.config.query), getActiveFeaturedFlags(state.config.featureFlags)), {
            [Constants.QueryStrings.UseSecondarySearch]: state.config.featureFlags.UseSecondarySearch
        });
        let getFilteredCloudsIndustry$;
        if (__CLIENT__) {
            getFilteredCloudsIndustry$ = entityRestClient.getFilteredCloudsIndustry({
                urlQuery,
                requestId
            });
        } else {
            getFilteredCloudsIndustry$ = cloudsIndustryViewService.getFilteredCloudsIndustry({
                request: mockRequest({
                    state: getState(),
                    query: urlQuery,
                    request
                })
            });
        }
        return getFilteredCloudsIndustry$.then((result)=>{
            const { items, count, showingResultsFor = '' } = result;
            dispatch(createEntityDataReceivedAction({
                entityType: Constants.EntityType.CloudsIndustry,
                dataList: items,
                isEmbedded: false,
                userSegment,
                count,
                urlQuery
            }));
            // This is to ensure we don't accidently reset the showing results for due to the 3 searches we're doing: Apps, Consulting Services, Industry Clouds
            if (urlQuery.search !== previousSearchText && showingResultsFor.length > 0) {
                dispatch(createShowingResultsForReceivedAction({
                    showingResultsFor,
                    previousSearchText: urlQuery.search
                }));
            }
            return result;
        });
    };
}
export function ensureFeaturedApps() {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const action = Constants.Telemetry.Action.GetFeaturedApps;
            const start = Date.now();
            telemtry(action, Constants.Telemetry.ActionModifier.Start, {});
            try {
                const featuredApps = yield featuredAppsService.getFeaturedAppsItems({
                    request: mockRequest({
                        state: getState()
                    })
                });
                dispatch(createFeaturedAppsReceivedAction({
                    featuredApps
                }));
                return featuredApps;
            } catch (error) {
                telemtry(action, Constants.Telemetry.ActionModifier.Error, {
                    duration: Date.now() - start,
                    error: stringifyError(error)
                });
            }
        })();
    };
}
export function fetchStateCacheData({ billingRegion, request }) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const dataMaps = [
                dispatch(ensureAppsDataMap()),
                dispatch(ensureServicesDataMap())
            ];
            if (!getState().config.isEmbedded) {
                dataMaps.push(dispatch(ensureCloudsIndustryDataMap()));
            }
            yield Promise.all(dataMaps);
            const offers = [
                dispatch(ensureAppData({
                    billingRegion,
                    request
                }))
            ];
            if (!getState().config.isEmbedded) {
                offers.push(dispatch(ensureServiceData({
                    request
                })), dispatch(ensureCloudsIndustryData({
                    request
                })));
            }
            yield Promise.all(offers);
            yield dispatch(ensureFeaturedApps());
            if (!getState().config.isEmbedded) {
                yield dispatch(ensureServiceCountries());
            }
        })();
    };
}
function logSearchTelemetry(actionModifier, detailsObject) {
    const payload = {
        page: getWindow().location.href,
        action: Constants.Telemetry.Action.Search,
        actionModifier,
        details: JSON.stringify(detailsObject)
    };
    logger.info(payload.details, {
        action: payload.action,
        actionModifier: payload.actionModifier
    });
}
const logSearchApiSuggestions = ({ details })=>{
    const payload = {
        page: getWindow().location.href,
        action: Constants.Telemetry.Action.NewSearchApi,
        actionModifier: Constants.Telemetry.ActionModifier.SearchApiSuggestions,
        details
    };
    logger.info(details, {
        action: payload.action,
        actionModifier: payload.actionModifier
    });
};
const logSearchApiSuggestionsError = ({ details })=>{
    const payload = {
        page: getWindow().location.href,
        action: Constants.Telemetry.Action.NewSearchApi,
        actionModifier: Constants.Telemetry.ActionModifier.SearchApiSuggestionsError,
        details
    };
    logger.error(details, {
        action: payload.action,
        actionModifier: payload.actionModifier
    });
};
export const extractSuggestionsResults = ({ suggestions = {
    totalCount: 0,
    value: []
} })=>{
    let wordSearches;
    let entityIds;
    suggestions.value.forEach((suggestion)=>{
        if (suggestion.suggestionType === Constants.Search.SuggestionTypes.Entity) {
            entityIds = [
                ...entityIds,
                suggestion.id
            ];
        }
        if (suggestion.suggestionType === Constants.Search.SuggestionTypes.WordSearch) {
            wordSearches = [
                ...wordSearches,
                suggestion.displayText
            ];
        }
    });
    return {
        wordSearches,
        entityIds
    };
};
export function callSearchApiSuggestionsAction({ language, searchText, requestId }) {
    return function(dispatch, getState) {
        const { config: { searchApiEndpoint, storefrontName, siteEnvironment } } = getState();
        const appName = `${storefrontName}-${siteEnvironment}`;
        suggestionsRestClient.callSearchApiSuggestions({
            searchText,
            language,
            endpoint: searchApiEndpoint,
            requestId,
            appName
        }).then((suggestions)=>{
            const { wordSearches, entityIds } = extractSuggestionsResults({
                suggestions
            });
            const details = JSON.stringify({
                searchText,
                totalCount: suggestions.totalCount,
                totalWordSearch: wordSearches.length,
                totalEntity: entityIds.length,
                wordSearches,
                entityIds,
                language,
                requestId
            });
            logSearchApiSuggestions({
                details
            });
        }).catch((error)=>{
            logSearchApiSuggestionsError({
                details: JSON.stringify({
                    searchText,
                    requestId,
                    error
                })
            });
        });
    };
}
const extractSearchPromises = ({ entityType, urlQuery, requestId, state })=>{
    const emptyResults = Promise.resolve({
        items: [],
        count: 0,
        requestId: Constants.ReservedCorrelationIds.EmptyId
    });
    const appsResults$ = entityType === Constants.FilteredSearchType.All || entityType === Constants.FilteredSearchType.Apps ? entityRestClient.getFilteredApps({
        urlQuery,
        searchActionType: Constants.Search.ActionType.Suggestions,
        requestId
    }) : emptyResults;
    const servicesResults$ = entityType === Constants.FilteredSearchType.All || entityType === Constants.FilteredSearchType.Services ? entityRestClient.getFilteredServices({
        urlQuery,
        searchActionType: Constants.Search.ActionType.Suggestions,
        requestId
    }) : emptyResults;
    const cloudsIndustryResults$ = state.config.isAppSource && (entityType === Constants.FilteredSearchType.All || entityType === Constants.FilteredSearchType.CloudsIndustry) ? entityRestClient.getFilteredCloudsIndustry({
        urlQuery,
        searchActionType: Constants.Search.ActionType.Suggestions,
        requestId
    }) : emptyResults;
    return {
        appsResults$,
        servicesResults$,
        cloudsIndustryResults$
    };
};
export function performFilteredSearch({ entityType, searchString, searchId, considerFilters, requestId }) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const startTime = Date.now();
            let searchPhase = Constants.FilteredSearchPhase.Started;
            const resultsString = Constants.searchTypeString.AppsAndServices;
            searchString = getSearchQuery(searchString);
            dispatch(createSearchboxInputChangedAction({
                searchString
            }));
            const state = getState();
            const urlQuery = _object_spread(_object_spread_props(_object_spread({}, considerFilters ? state.config.requestFilteredQuery : {}), {
                [Constants.TileDataAdditionalQueryParams.country]: state.services.selectedCountry,
                [Constants.TileDataAdditionalQueryParams.region]: state.services.selectedRegion,
                [Constants.TileDataAdditionalQueryParams.page]: '1',
                [Constants.TileDataFilteredQueryParams.search]: searchString
            }), getActiveFeaturedFlags(state.config.featureFlags));
            const { appsResults$, servicesResults$, cloudsIndustryResults$ } = extractSearchPromises({
                entityType,
                urlQuery,
                requestId,
                state
            });
            return Promise.all([
                appsResults$,
                servicesResults$,
                cloudsIndustryResults$
            ]).then(([appsResults, servicesResults, cloudsIndustryResults])=>{
                var _apps_, _services_, _cloudsIndustry_;
                searchPhase = Constants.FilteredSearchPhase.SearchResultsReturned;
                const duration = Date.now() - startTime;
                let bundleCount = 0;
                let apps = appsResults.items;
                const services = servicesResults.items;
                const cloudsIndustry = cloudsIndustryResults.items;
                const results = removeDuplicateAddIns(apps, 'entityId');
                apps = results.apps;
                bundleCount = results.bundleCount;
                searchPhase = Constants.FilteredSearchPhase.DuplicateAddInsRemoved;
                const requestId = appsResults.requestId || servicesResults.requestId || cloudsIndustryResults.requestId;
                const searchResponseId = appsResults.searchResponseId;
                dispatch(createFilteredSearchResultsReceivedAction({
                    appSearchResults: apps,
                    servicesSearchResults: services,
                    cloudsIndustrySearchResults: cloudsIndustry,
                    appsCount: appsResults.count - results.duplicateAddInsCount,
                    servicesCount: servicesResults.count,
                    cloudsIndustryCount: cloudsIndustryResults.count,
                    searchid: searchId + 1,
                    requestId,
                    searchResponseId
                }));
                searchPhase = Constants.FilteredSearchPhase.SearchActionCreated;
                logSearchTelemetry(Constants.Telemetry.ActionModifier.Suggestions, {
                    results: resultsString,
                    searchTerm: searchString,
                    appResults: (apps === null || apps === void 0 ? void 0 : apps.length) || 0,
                    servicesResults: (services === null || services === void 0 ? void 0 : services.length) || 0,
                    cloudsIndustry: (cloudsIndustry === null || cloudsIndustry === void 0 ? void 0 : cloudsIndustry.length) || 0,
                    bundleAppResults: bundleCount,
                    duration,
                    origin: ((_apps_ = apps[0]) === null || _apps_ === void 0 ? void 0 : _apps_.origin) || ((_services_ = services[0]) === null || _services_ === void 0 ? void 0 : _services_.origin) || ((_cloudsIndustry_ = cloudsIndustry[0]) === null || _cloudsIndustry_ === void 0 ? void 0 : _cloudsIndustry_.origin) || null,
                    topResults: takeTopResults({
                        apps,
                        services,
                        cloudsIndustry
                    }),
                    requestId,
                    searchResponseId
                });
                searchPhase = Constants.FilteredSearchPhase.SearchTelemetryLogged;
                return [
                    apps,
                    services,
                    cloudsIndustry
                ];
            }).catch((error)=>{
                var _error_response;
                logSearchTelemetry(Constants.Telemetry.ActionModifier.Error, {
                    results: resultsString,
                    searchTerm: searchString,
                    duration: Date.now() - startTime,
                    error: stringifyError(error),
                    responseError: (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.body,
                    searchPhase
                });
                return [
                    [],
                    [],
                    []
                ];
            });
        })();
    };
}
/** Get product from ARM, for private OR for public. If private or both do cannot be found, this means one of the following:
 * 1. There's an issue with catalog and ingestion (probably ICM)
 * 2. It's a preview offer, in that case there should be flightcode with the request
 * */ export function getProduct(entityId, market) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            dispatch(createFetchingProductAction());
            let product;
            try {
                const mprpAppData = yield armRestClient.getPrivateOrPublicPublicId(entityId, market); // Catches restricted audience
                product = new Product(mprpAppData);
            } catch (ex) {
                // Search for preview offer in CatalogApi with flightCode.
                // Call from armRestClient doesn't accept flight code so we have to call catalogApi directly.
                // This is relevant for publishers who want to test the preview without adding themselves to the restricted audience list for preview
                const flightCodes = getState().config.flightCodes;
                const mprpAppData = yield catalogApiRestClient.getProduct(entityId, flightCodes, market);
                product = new Product(mprpAppData);
            } finally{
                dispatch(createProduct({
                    id: entityId,
                    product
                }));
            }
        })();
    };
}
export function performPartnersSearch(searchString) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const startTime = Date.now();
            const searchPhase = Constants.FilteredSearchPhase.Started;
            const resultsString = Constants.searchTypeString.Partners;
            searchString = getSearchQuery(searchString);
            dispatch(createSearchboxInputChangedAction({
                searchString
            }));
            if (searchString.length < 2) {
                return;
            }
            const partnerSearchResponse = yield entityRestClient.searchPartners(searchString, getState().config.locale || Constants.DefaultLocale, getState().config.partnersApiHost).catch((error)=>{
                logSearchTelemetry(Constants.Telemetry.ActionModifier.Error, {
                    results: resultsString,
                    searchTerm: searchString,
                    duration: Date.now() - startTime,
                    error: stringifyError(error),
                    searchPhase
                });
                return [
                    [],
                    [],
                    []
                ];
            });
            let partnerSearchResults = [];
            if (partnerSearchResponse && partnerSearchResponse.suggestions) {
                partnerSearchResults = partnerSearchResponse.suggestions.map((suggestion)=>{
                    return {
                        id: suggestion.val,
                        logo: undefined,
                        text: suggestion.text,
                        type: Constants.searchItemType.partner,
                        original: {
                            type: suggestion.type,
                            val: suggestion.val,
                            text: suggestion.text
                        }
                    };
                });
            }
            dispatch(createPartnerSearchResultsReceivedAction({
                partnerSearchResults
            }));
        })();
    };
}
export function performSearchAll(rawSearchText, // eslint-disable-next-line @typescript-eslint/no-unused-vars
searchSortingOption = Constants.SearchSortingOption.BestMatch) {
    return function(dispatch) {
        return dispatchSearchQueryChangedAction(dispatch, rawSearchText);
    };
}
export function getAppPricing(entityId) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const { isEmbedded, billingCountryCode: billingRegion, flightCodes, featureFlags } = getState().config;
            const urlQuery = getActiveFeaturedFlags(featureFlags);
            let appPricing$;
            if (__CLIENT__) {
                appPricing$ = entityRestClient.getAppPricing({
                    entityId,
                    isEmbedded,
                    flightCodes,
                    billingRegion,
                    urlQuery
                });
            } else {
                appPricing$ = pricingViewService.getAppDetailPricing({
                    request: mockRequest({
                        state: getState()
                    }),
                    entityId,
                    isEmbedded,
                    billingRegion,
                    flightCodes,
                    featureFlags
                });
            }
            let futurePrices$;
            if (__CLIENT__) {
                futurePrices$ = entityRestClient.getFuturePrices({
                    entityId,
                    isEmbedded,
                    flightCodes,
                    billingRegion
                });
            } else {
                futurePrices$ = pricingViewService.getAppDetailFuturePricing({
                    request: mockRequest({
                        state: getState()
                    }),
                    entityId,
                    isEmbedded,
                    billingRegion,
                    flightCodes,
                    featureFlags
                });
            }
            const [pricing, futurePrices] = yield Promise.all([
                appPricing$.catch((error)=>{
                    dispatch(createAppDetailPricingReceivedAction({
                        entityId,
                        pricing: {
                            billingRegion
                        },
                        futurePrices: null
                    }));
                    throw error;
                }),
                futurePrices$.catch(()=>{
                    // If the request for future price failed the PDP will be load without future price.
                    return null;
                })
            ]);
            dispatch(createAppDetailPricingReceivedAction({
                entityId,
                pricing,
                futurePrices
            }));
            return [
                pricing,
                futurePrices
            ];
        })();
    };
}
export function getAppDetail(entityId, isPrivate) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const { billingCountryCode: billingRegion, flightCodes, isConverged } = getState().config;
            let entityDetails$;
            if (isPrivate) {
                entityDetails$ = ensurePrivateOffer(entityId, billingRegion, getState);
            } else {
                if (__CLIENT__) {
                    entityDetails$ = entityRestClient.getApp({
                        entityId,
                        flightCodes,
                        isConverged
                    });
                } else {
                    entityDetails$ = detailsViewService.getAppDetailView({
                        entityId,
                        flightCodes,
                        isConverged,
                        request: mockRequest({
                            state: getState()
                        })
                    });
                }
            }
            const entityDetails = yield entityDetails$;
            if (isPrivate) {
                if (entityDetails) {
                    dispatch(createPrivateEntityFullDataReceivedAction({
                        entityType: Constants.EntityType.App,
                        entityDetails
                    }));
                    const pricingPayload = {
                        pricingData: {
                            [entityDetails.entityId]: entityDetails.startingPrice
                        },
                        countryCode: billingRegion
                    };
                    dispatch(createPrivateAppsPricingDataReceivedAction(pricingPayload));
                }
            } else {
                dispatch(createEntityDetailsReceivedAction({
                    entityType: Constants.EntityType.App,
                    entityDetails
                }));
                dispatch(createEntityDetailsReceivedAction({
                    entityType: Constants.EntityType.CloudsIndustry,
                    entityDetails
                }));
                dispatch(fetchPricingAction({
                    countryCode: billingRegion,
                    apps: [
                        entityDetails
                    ]
                }));
            }
            return entityDetails;
        })();
    };
}
export function getAppRelatedAppsItems(entityId) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            var _getProductByUrlKey;
            const action = Constants.Telemetry.Action.GetAppSuggestedItems;
            const { billingCountryCode } = getState().config;
            const start = Date.now();
            const embedHost = (_getProductByUrlKey = getProductByUrlKey({
                urlKey: getState().config.embedHost
            })) === null || _getProductByUrlKey === void 0 ? void 0 : _getProductByUrlKey.UrlKey;
            telemtry(action, Constants.Telemetry.ActionModifier.Start, {
                entityId,
                embedHost
            });
            dispatch(createRelatedAppsItemsLoadingAction({
                entityType: Constants.EntityType.App,
                entityId
            }));
            let relatedAppsItems$;
            if (__CLIENT__) {
                relatedAppsItems$ = entityRestClient.getAppRelatedAppsItems(entityId, embedHost);
            } else {
                relatedAppsItems$ = tilesViewService.getAppRelatedAppsItemsView({
                    entityId,
                    embedHost,
                    request: mockRequest({
                        state: getState()
                    }),
                    flightCodes: getState().config.flightCodes
                });
            }
            try {
                var _relatedAppsItems_suggestedItems, _relatedAppsItems_saasLinkingItems, _relatedAppsItems_linkedAddIns;
                const relatedAppsItems = (yield relatedAppsItems$) || {
                    saasLinkingItems: [],
                    suggestedItems: [],
                    linkedAddIns: []
                };
                telemtry(action, Constants.Telemetry.ActionModifier.End, {
                    duration: Date.now() - start,
                    entityId,
                    suggestedItems: (_relatedAppsItems_suggestedItems = relatedAppsItems.suggestedItems) === null || _relatedAppsItems_suggestedItems === void 0 ? void 0 : _relatedAppsItems_suggestedItems.map((item)=>item.entityId),
                    saasLinkingItems: (_relatedAppsItems_saasLinkingItems = relatedAppsItems.saasLinkingItems) === null || _relatedAppsItems_saasLinkingItems === void 0 ? void 0 : _relatedAppsItems_saasLinkingItems.map((item)=>item.entityId),
                    linkedAddIns: (_relatedAppsItems_linkedAddIns = relatedAppsItems.linkedAddIns) === null || _relatedAppsItems_linkedAddIns === void 0 ? void 0 : _relatedAppsItems_linkedAddIns.map((item)=>item.entityId)
                });
                dispatch(createRelatedAppsItemsReceivedAction({
                    entityType: Constants.EntityType.App,
                    entityId,
                    relatedAppsItems
                }));
                const relatedApps = [
                    ...relatedAppsItems.linkedAddIns,
                    ...relatedAppsItems.saasLinkingItems,
                    ...relatedAppsItems.suggestedItems
                ];
                dispatch(fetchPricingAction({
                    countryCode: billingCountryCode,
                    apps: relatedApps
                }));
                return relatedAppsItems;
            } catch (error) {
                telemtry(action, Constants.Telemetry.ActionModifier.Error, {
                    duration: Date.now() - start,
                    entityId,
                    error: stringifyError(error)
                });
                throw error;
            }
        })();
    };
}
export function getServiceRelatedAppsItems(entityId) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const start = Date.now();
            const action = Constants.Telemetry.Action.GetServiceSuggestedItems;
            const query = getState().config.query;
            const country = extractCountryCodeFromQueryParam(query);
            const region = query && query.region || getState().services.selectedRegion;
            telemtry(action, Constants.Telemetry.ActionModifier.Start, {
                entityId
            });
            dispatch(createRelatedAppsItemsLoadingAction({
                entityType: Constants.EntityType.Service,
                entityId
            }));
            try {
                var _relatedAppsItems_suggestedItems, _relatedAppsItems_saasLinkingItems, _relatedAppsItems_linkedAddIns;
                let relatedAppsItems$;
                if (__CLIENT__) {
                    relatedAppsItems$ = entityRestClient.getServiceRelatedAppsItems(entityId, country, region);
                } else {
                    relatedAppsItems$ = servicesViewService.getServiceSuggestedItemsView({
                        country,
                        region,
                        entityId,
                        request: mockRequest({
                            state: getState()
                        })
                    });
                }
                const relatedAppsItems = (yield relatedAppsItems$) || {
                    saasLinkingItems: [],
                    suggestedItems: [],
                    linkedAddIns: []
                };
                telemtry(action, Constants.Telemetry.ActionModifier.End, {
                    duration: Date.now() - start,
                    entityId,
                    suggestedItems: (_relatedAppsItems_suggestedItems = relatedAppsItems.suggestedItems) === null || _relatedAppsItems_suggestedItems === void 0 ? void 0 : _relatedAppsItems_suggestedItems.map((item)=>item.entityId),
                    saasLinkingItems: (_relatedAppsItems_saasLinkingItems = relatedAppsItems.saasLinkingItems) === null || _relatedAppsItems_saasLinkingItems === void 0 ? void 0 : _relatedAppsItems_saasLinkingItems.map((item)=>item.entityId),
                    linkedAddIns: (_relatedAppsItems_linkedAddIns = relatedAppsItems.linkedAddIns) === null || _relatedAppsItems_linkedAddIns === void 0 ? void 0 : _relatedAppsItems_linkedAddIns.map((item)=>item.entityId)
                });
                dispatch(createRelatedAppsItemsReceivedAction({
                    entityType: Constants.EntityType.Service,
                    entityId,
                    relatedAppsItems
                }));
                return relatedAppsItems;
            } catch (error) {
                telemtry(action, Constants.Telemetry.ActionModifier.Error, {
                    duration: Date.now() - start,
                    entityId,
                    error: stringifyError(error)
                });
                throw error;
            }
        })();
    };
}
export function changeBillingRegion({ countryCode, shouldSetCountyCodeCookie = true }) {
    return (dispatch, getState)=>_async_to_generator(function*() {
            var _relatedAppsItems_items, _relatedAppsItems_items1, _relatedAppsItems_items2, _cloudRelatedAppsItems_items, _cloudRelatedAppsItems_items1, _cloudRelatedAppsItems_items2;
            const { billingCountryCode, startingPricingData = {} } = getState().config;
            const { apps: userFavouriteApps } = getState().userFavourite;
            const { dataList: appsList, relatedAppsItems, featuredApps } = getState().apps;
            const { dataList: cloudIndustryAppsList, relatedAppsItems: cloudRelatedAppsItems } = getState().cloudsIndustry;
            if (!countryCode) {
                countryCode = getCookieItem(Constants.Cookies.billingRegionCookie, false) || AzureEnvironmentSettings.defaultCountryCode;
            }
            dispatch(setBillingRegionAction({
                billingRegion: countryCode
            }));
            if (countryCode === billingCountryCode && Object.keys(startingPricingData).length) {
                return;
            }
            dispatch(createAppsPricingDataResetAction());
            if (countryCode && shouldSetCountyCodeCookie) {
                saveCookieItem(Constants.Cookies.billingRegionCookie, countryCode);
            }
            const apps = [
                ...appsList,
                ...cloudIndustryAppsList,
                ...(relatedAppsItems === null || relatedAppsItems === void 0 ? void 0 : (_relatedAppsItems_items = relatedAppsItems.items) === null || _relatedAppsItems_items === void 0 ? void 0 : _relatedAppsItems_items.linkedAddIns) || [],
                ...(relatedAppsItems === null || relatedAppsItems === void 0 ? void 0 : (_relatedAppsItems_items1 = relatedAppsItems.items) === null || _relatedAppsItems_items1 === void 0 ? void 0 : _relatedAppsItems_items1.saasLinkingItems) || [],
                ...(relatedAppsItems === null || relatedAppsItems === void 0 ? void 0 : (_relatedAppsItems_items2 = relatedAppsItems.items) === null || _relatedAppsItems_items2 === void 0 ? void 0 : _relatedAppsItems_items2.suggestedItems) || [],
                ...(cloudRelatedAppsItems === null || cloudRelatedAppsItems === void 0 ? void 0 : (_cloudRelatedAppsItems_items = cloudRelatedAppsItems.items) === null || _cloudRelatedAppsItems_items === void 0 ? void 0 : _cloudRelatedAppsItems_items.linkedAddIns) || [],
                ...(cloudRelatedAppsItems === null || cloudRelatedAppsItems === void 0 ? void 0 : (_cloudRelatedAppsItems_items1 = cloudRelatedAppsItems.items) === null || _cloudRelatedAppsItems_items1 === void 0 ? void 0 : _cloudRelatedAppsItems_items1.saasLinkingItems) || [],
                ...(cloudRelatedAppsItems === null || cloudRelatedAppsItems === void 0 ? void 0 : (_cloudRelatedAppsItems_items2 = cloudRelatedAppsItems.items) === null || _cloudRelatedAppsItems_items2 === void 0 ? void 0 : _cloudRelatedAppsItems_items2.suggestedItems) || [],
                ...(userFavouriteApps === null || userFavouriteApps === void 0 ? void 0 : userFavouriteApps.map(({ item })=>item)) || [],
                ...featuredApps.gallery.flatMap(({ featuredApps })=>featuredApps.map((item)=>item)) || [],
                ...featuredApps.homepage.flatMap(({ featuredApps })=>featuredApps.map((item)=>item)) || []
            ];
            dispatch(fetchPricingAction({
                countryCode,
                apps
            }));
        })();
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function updateUserInfoForEmbed(userInfo) {
    const cookie = getCookieItem('appsourcelead');
    let isAlternateEmailFromCookie = false;
    if (cookie && cookie.alternateEmail && cookie.email) {
        const userEmail = userInfo && userInfo.email ? userInfo.email.toLowerCase() : ' ';
        // If userInfo already has alternateEmail (from graph call on server), do NOT overwrite it here
        // also ensure that cookie's email is matching useremail to avoid scenario where user signs in into other sites that updated the cookie to some MSA
        if (!userInfo.alternateEmail && userEmail === cookie.email.toLowerCase()) {
            userInfo.alternateEmail = cookie.alternateEmail;
            isAlternateEmailFromCookie = true;
        }
    }
    const payload = {
        page: getWindow().location.href,
        action: Constants.Telemetry.Action.PageLoad,
        actionModifier: Constants.Telemetry.ActionModifier.CookieData,
        details: JSON.stringify({
            alternateEmailExists: !!(cookie && cookie.alternateEmail),
            emailHasOnMicrosoft: userInfo && userInfo.email ? isOnMicrosoftEmail(userInfo.email) : false,
            alternateEmailFromCookie: isAlternateEmailFromCookie
        })
    };
    logger.info(payload.details, {
        action: payload.action,
        actionModifier: payload.actionModifier
    });
    return userInfo;
}
export function sendLead(payload) {
    return function() {
        return _async_to_generator(function*() {
            const requestId = generateGuid();
            telemtry(Constants.Telemetry.Action.SendLead, Constants.Telemetry.ActionModifier.InProgress, {
                payload: scrubLeadPayload(payload),
                requestId
            });
            const startTime = Date.now();
            try {
                yield leadgenRestClient.sendLead(payload, {
                    requestId
                });
                telemtry(Constants.Telemetry.Action.SendLead, Constants.Telemetry.ActionModifier.End, {
                    duration: Date.now() - startTime,
                    requestId
                });
            } catch (error) {
                const errorMessage = stringifyError(error);
                telemtry(Constants.Telemetry.Action.SendLead, Constants.Telemetry.ActionModifier.Error, {
                    errorMessage,
                    duration: Date.now() - startTime,
                    requestId
                });
                throw new Error(errorMessage);
            }
        })();
    };
}
export function sendLeadInfo({ item, ctaType, notes, planId }) {
    return function(dispatch, getState) {
        try {
            telemtry(Constants.Telemetry.Action.SendLeadInfo, Constants.Telemetry.ActionModifier.Start, {});
            if (!item) {
                throw new Error(Constants.Telemetry.LeadsDropReason.ItemNotAvailable);
            }
            const isService = item.entityType === Constants.EntityType.Service;
            const state = getState();
            const userState = state.users;
            const customerInfo = {
                firstName: userState.profile.firstName,
                lastName: userState.profile.lastName,
                phone: userState.profile.phone,
                country: userState.profile.country,
                company: userState.profile.company,
                title: userState.profile.title
            };
            const { landingView, currentView, isEmbedded, embedHost, isConverged } = state.config;
            const url = getWindow().location.href;
            const campaigns = getCampaignsForAcquisitionFromUrl({
                url,
                landingView,
                currentView,
                previousPage,
                routes,
                entityId: item.entityId
            });
            const privateApp = isService ? false : item === null || item === void 0 ? void 0 : item.privateApp;
            const actionCode = isService ? Constants.ActionCodes.ConsultingServices : undefined;
            const payload = createLeadPayload({
                entityId: item.entityId,
                privateApp,
                ctaType,
                actionCode,
                campaigns,
                customerInfo,
                notes,
                uniquePlanId: planId,
                isEmbedded,
                embedHost,
                isConverged
            });
            return Promise.all([
                dispatch(sendLead(payload)),
                dispatch(createClearUserPropertiesAction(null))
            ]);
        } catch (error) {
            telemtry(Constants.Telemetry.Action.SendLeadInfo, Constants.Telemetry.ActionModifier.Error, {
                error
            });
            throw error;
        }
    };
}
export function loadUserProductReviewMetadata({ legacyId }) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const { reviewsAPI, reviewsAPIVersion, featureFlags: { ReviewsMyCommentsFilter } } = getState().config;
            if (ReviewsMyCommentsFilter === 'true') {
                try {
                    const { commentReviewIds } = yield reviewsCatalogRestClient.getReviewsMetadata({
                        reviewsAPI,
                        reviewsAPIVersion,
                        legacyId
                    });
                    dispatch(createEntityUserCommentedReviewIdsUpdateListAction({
                        commentReviewIds
                    }));
                } catch (error) {
                    launchReviewsTelemetry(Constants.Telemetry.Action.Error, Constants.Telemetry.ActionModifier.ReviewItemCommentedReviewIds, {
                        error
                    });
                    logger.error(stringifyError(error), {
                        action: Constants.Telemetry.Action.Error,
                        actionModifier: Constants.Telemetry.ActionModifier.ReviewItemCommentedReviewIds
                    });
                    dispatch(createEntityUserCommentedReviewIdsUpdateListAction({
                        commentReviewIds: []
                    }));
                }
            }
        })();
    };
}
export function getReviews(authMethod, authKey, entityId) {
    return function() {
        return reviewRestClient.get(authMethod, authKey, entityId);
    };
}
export function deleteReview(reviewFormData) {
    return function(dispatch, getState) {
        const { reviewsAPI, reviewsAPIVersion } = getState().config;
        const { reviewId, offerId } = reviewFormData;
        return userReviewRestClient.remove({
            reviewsAPI,
            reviewsAPIVersion,
            reviewId
        }).then(()=>dispatch(getAppReviews(offerId)), dispatch(loadUserProductReviewMetadata({
            legacyId: offerId
        })));
    };
}
export function submitReview(reviewFormData) {
    return function(dispatch, getState) {
        const { reviewsAPI, reviewsAPIVersion, storefrontName, isConverged } = getState().config;
        const { offerId } = reviewFormData;
        const source = isConverged ? Constants.StorefrontName.Marketplace : storefrontName;
        return userReviewRestClient.submit(_object_spread_props(_object_spread({
            reviewsAPI,
            reviewsAPIVersion
        }, reviewFormData), {
            source
        })).then(()=>dispatch(getAppReviews(offerId)));
    };
}
export function updateReview(reviewFormData) {
    return function(dispatch, getState) {
        const { reviewsAPI, reviewsAPIVersion } = getState().config;
        const { offerId } = reviewFormData;
        return userReviewRestClient.update(_object_spread({
            reviewsAPI,
            reviewsAPIVersion
        }, reviewFormData)).then(()=>dispatch(getAppReviews(offerId)));
    };
}
export function getReportEmbedToken(reportData) {
    return function() {
        return fieldHubRestClient.generateReportEmbedToken(reportData);
    };
}
// for appsource, we do not support field hub yet
export function updateFieldHubUserType() {
    return function() {
        return Promise.resolve();
    };
}
export function getFilteredServiceData() {
    return function() {
        return Promise.resolve();
    };
}
export function getAppReviewCommentCollection({ offerId, reviewId, page, itemsPerPage }) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const { reviewsAPI, reviewsAPIVersion } = getState().config;
            dispatch(createEntityReviewCommentsLoadingAction({
                offerId,
                reviewId,
                isLoading: true
            }));
            const res = yield appReviewCommentsRestClient.getAppReviewComments({
                offerId,
                reviewId,
                page,
                itemsPerPage,
                reviewsAPI,
                reviewsAPIVersion
            });
            dispatch(createEntityReviewCommentsUpdateTotalCommentCountAction({
                reviewId,
                offerId,
                totalComments: res.totalComments
            }));
            dispatch(createEntityReviewCommentsReceivedAction({
                offerId,
                reviewId,
                comments: res.comments,
                pageNumber: page
            }));
            dispatch(createEntityReviewCommentsLoadingAction({
                offerId,
                reviewId,
                isLoading: false
            }));
        })();
    };
}
export function clearAppReviewCommentCollection({ offerId, reviewId }) {
    return function(dispatch) {
        dispatch(createEntityReviewCommentsCleanupAction({
            reviewId,
            offerId
        }));
    };
}
export function ensureAppReviewCommentCollectionData({ offerId, reviewId, page, itemsPerPage }) {
    return function(dispatch) {
        dispatch(getAppReviewCommentCollection({
            offerId,
            reviewId,
            page,
            itemsPerPage
        }));
    };
}
export function ensureAppReviewCommentCollectionStateInitialized({ offerId, reviewId, totalComments }) {
    return function(dispatch) {
        dispatch(createEntityReviewCommentsInitializeStateAction({
            offerId,
            reviewId,
            totalComments
        }));
    };
}
export function ensureClearAppReviewCommentCollectionData({ offerId, reviewId }) {
    return function(dispatch) {
        dispatch(clearAppReviewCommentCollection({
            offerId,
            reviewId
        }));
    };
}
export function createAppReviewComment({ offerId, reviewId, commentContent, isNewlyAddedComment = false }) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const { reviewsAPI, reviewsAPIVersion, storefrontName: source } = getState().config;
            dispatch(createEntityReviewCommentModalAction({
                showModal: true,
                modalMode: Constants.Reviews.ReviewCommentModalMode.Loading
            }));
            const actionResult = yield appReviewCommentsRestClient.createReviewComment({
                offerId,
                reviewId,
                commentContent,
                reviewsAPI,
                reviewsAPIVersion,
                source
            });
            dispatch(createEntityReviewCommentCreateResult({
                reviewId,
                offerId,
                actionResult,
                isNewlyAddedComment
            }));
            if (!actionResult || actionResult.error) {
                dispatch(createEntityReviewCommentModalAction({
                    showModal: true,
                    modalMode: actionResult.error === Constants.Reviews.ReviewCommentActionError.ContentViolation ? Constants.Reviews.ReviewCommentModalMode.ContentViolation : Constants.Reviews.ReviewCommentModalMode.CreateError
                }));
            } else {
                // Hide loader
                dispatch(createEntityReviewCommentModalAction({
                    showModal: false,
                    modalMode: Constants.Reviews.ReviewCommentModalMode.Loading
                }));
                dispatch(loadUserProductReviewMetadata({
                    legacyId: offerId
                }));
            }
            return actionResult;
        })();
    };
}
export function deleteReviewComment({ offerId, reviewId, commentId, isNewlyAddedComment = false }) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const { reviewsAPI, reviewsAPIVersion } = getState().config;
            const actionResult = yield appReviewCommentsRestClient.deleteReviewComment({
                offerId,
                reviewId,
                commentId,
                reviewsAPI,
                reviewsAPIVersion
            });
            dispatch(createEntityReviewCommentDeleteResult({
                reviewId,
                offerId,
                actionResult,
                isNewlyAddedComment
            }));
            dispatch(loadUserProductReviewMetadata({
                legacyId: offerId
            }));
            return actionResult;
        })();
    };
}
export function updateReviewComment({ offerId, reviewId, commentId, commentContent, isNewlyAddedComment = false }) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const { reviewsAPI, reviewsAPIVersion } = getState().config;
            const actionResult = yield appReviewCommentsRestClient.updateReviewComment({
                offerId,
                reviewId,
                commentId,
                commentContent,
                reviewsAPI,
                reviewsAPIVersion
            });
            dispatch(createEntityReviewCommentUpdateResult({
                reviewId,
                offerId,
                actionResult,
                isNewlyAddedComment
            }));
            return actionResult;
        })();
    };
}
export function loadUserMarkedAsHelpfulReviews({ offerId }) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const { reviewsAPI, reviewsAPIVersion } = getState().config;
            const { reviewIds, error } = yield appReviewMarkAsHelpfulRestClient.getUserReviewsMarkedAsHelpful({
                reviewsAPI,
                reviewsAPIVersion,
                offerId
            });
            if (!error) {
                dispatch(createEntityMarkedAsHelpfulReviewUpdateListAction({
                    offerId,
                    reviewIds
                }));
            } else {
                launchReviewsTelemetry(Constants.Telemetry.Action.Error, Constants.Telemetry.ActionModifier.ReviewsGetMarkedAsHelpful, {
                    error
                });
                logger.error(JSON.stringify({
                    error
                }), {
                    action: Constants.Telemetry.Action.Error,
                    actionModifier: Constants.Telemetry.ActionModifier.ReviewsGetMarkedAsHelpful
                });
            }
        })();
    };
}
export function loadLinkedInProductGroup({ legacyOfferId }) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const { linkedinAPI, linkedinAPIVersion } = getState().config;
            try {
                const { linkedInProductGroup } = yield linkedInRestClient.getLinkedInProductgroupInfo({
                    legacyOfferId,
                    linkedinAPI,
                    linkedinAPIVersion
                });
                dispatch(createEntityLinkedInProductGroupUpdateAction({
                    legacyOfferId,
                    linkedInProductGroup
                }));
            } catch (error) {
                launchReviewsTelemetry(Constants.Telemetry.Action.Error, Constants.Telemetry.ActionModifier.GetLinkedInProductGroup, {
                    error
                });
                logger.error(stringifyError({
                    error
                }), {
                    action: Constants.Telemetry.Action.Error,
                    actionModifier: Constants.Telemetry.ActionModifier.GetLinkedInProductGroup
                });
            }
        })();
    };
}
export function reportItem(itemReport) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const { communityAPI, communityAPIVersion } = getState().config;
            try {
                yield reportReviewRestClient.createReportReview({
                    itemReport,
                    communityAPI,
                    communityAPIVersion
                });
            } catch (error) {
                launchReviewsTelemetry(Constants.Telemetry.Action.Error, Constants.Telemetry.ActionModifier.ReportReview, {
                    error
                });
                logger.error(stringifyError({
                    error
                }), {
                    action: Constants.Telemetry.Action.Error,
                    actionModifier: Constants.Telemetry.ActionModifier.ReportReview
                });
            }
        })();
    };
}
export function setReviewMarkedAsHelpful({ offerId, review, isHelpful }) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const state = getState();
            const { reviewsAPI, reviewsAPIVersion, storefrontName: source } = state.config;
            const { userReviewIdsLoading } = state.apps.appReviewsData.markedAsHelpful;
            const { id: reviewId, mark_as_helpful_count: prevMarkAsHelpfulCount } = review;
            const telemetryBasePayload = {
                offerId,
                reviewId,
                isHelpful
            };
            if (!userReviewIdsLoading[`${reviewId}`]) {
                dispatch(createEntityReviewSetIsHelpfulLoadingAction({
                    reviewId,
                    isLoading: true
                }));
                // Immediately update both the isHelpful value and the review's marked as helpful count to reflect the user's action
                dispatch(createEntityReviewSetIsHelpfulAction({
                    reviewId,
                    isHelpful
                }));
                dispatch(createEntityReviewSetMarkAsHelpfulCount({
                    count: prevMarkAsHelpfulCount + (isHelpful ? 1 : -1),
                    reviewId
                }));
                launchReviewsTelemetry(Constants.Telemetry.Action.Submitting, Constants.Telemetry.ActionModifier.ReviewSetMarkedAsHelpful, telemetryBasePayload);
                logger.info(JSON.stringify(telemetryBasePayload), {
                    action: Constants.Telemetry.Action.Submitting,
                    actionModifier: Constants.Telemetry.ActionModifier.ReviewSetMarkedAsHelpful
                });
                const { error } = yield appReviewMarkAsHelpfulRestClient.setReviewMarkedAsHelpful({
                    offerId,
                    reviewId,
                    reviewsAPI,
                    reviewsAPIVersion,
                    isHelpful,
                    source: isHelpful ? source : null
                });
                if (error) {
                    launchReviewsTelemetry(Constants.Telemetry.Action.SubmitError, Constants.Telemetry.ActionModifier.ReviewSetMarkedAsHelpful, _object_spread_props(_object_spread({}, telemetryBasePayload), {
                        error
                    }));
                    logger.error(JSON.stringify(_object_spread_props(_object_spread({}, telemetryBasePayload), {
                        error
                    })), {
                        action: Constants.Telemetry.Action.SubmitError,
                        actionModifier: Constants.Telemetry.ActionModifier.ReviewSetMarkedAsHelpful
                    });
                    // Display the error message
                    dispatch(createEntityReviewMarkAsHelpfulModalAction({
                        showModal: true
                    }));
                    // Set the is helpful and the count values back to what they were
                    dispatch(createEntityReviewSetMarkAsHelpfulCount({
                        count: prevMarkAsHelpfulCount,
                        reviewId
                    }));
                    dispatch(createEntityReviewSetIsHelpfulAction({
                        reviewId,
                        isHelpful: !isHelpful
                    }));
                } else {
                    launchReviewsTelemetry(Constants.Telemetry.Action.Submitted, Constants.Telemetry.ActionModifier.ReviewSetMarkedAsHelpful, telemetryBasePayload);
                    logger.info(JSON.stringify(telemetryBasePayload), {
                        action: Constants.Telemetry.Action.Submitted,
                        actionModifier: Constants.Telemetry.ActionModifier.ReviewSetMarkedAsHelpful
                    });
                }
                dispatch(createEntityReviewSetIsHelpfulLoadingAction({
                    reviewId,
                    isLoading: false
                }));
            }
        })();
    };
}
export function ensureAppDetailsData(entityId, isPrivate) {
    return function(dispatch, getState) {
        if (!entityId) {
            return Promise.resolve(false);
        }
        entityId = entityId.toLowerCase();
        if (entityId === getState().apps.entityIdLoading) {
            return Promise.resolve(false);
        }
        if (entityId === getState().apps.entityIdFailed) {
            return Promise.resolve(false);
        }
        const promises = [];
        if (!isPrivate && shouldEnsureAppDetails(entityId, getState())) {
            promises.push(dispatch(getAppDetail(entityId, isPrivate)));
        }
        if (isPrivate && (shouldEnsurePrivateAppDetails(entityId, getState()) || shouldEnsurePrivateAppPricings(entityId, getState()))) {
            promises.push(dispatch(getAppDetail(entityId, isPrivate)));
        }
        if (shouldEnsureAppPricings(entityId, getState()) && !isPrivate) {
            promises.push(dispatch(getAppPricing(entityId)));
        }
        if (shouldEnsureAppRelatedApps(entityId, getState()) && !isPrivate) {
            promises.push(dispatch(getAppRelatedAppsItems(entityId)));
        }
        if (!promises.length) {
            return Promise.resolve(false);
        }
        dispatch(createSetEntityIdLoadingAction({
            entityType: Constants.EntityType.App,
            entityId
        }));
        dispatch(createSetEntityIdFailedAction({
            entityType: Constants.EntityType.App,
            entityId: ''
        }));
        const start = Date.now();
        return Promise.all(promises).then(()=>{
            const payload = {
                page: getWindow() && getWindow().location.href,
                action: Constants.Telemetry.Action.EnsureAppDetailsData,
                actionModifier: Constants.Telemetry.ActionModifier.End,
                details: JSON.stringify({
                    duration: Date.now() - start,
                    entityId
                })
            };
            SharedInstrumentService.getProvider().probe('logTelemetryInfo', payload);
            logger.info(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
            dispatch(createSetEntityIdLoadingAction({
                entityType: Constants.EntityType.App,
                entityId: ''
            }));
            return true;
        }).catch((error)=>{
            var _error_error;
            const payload = {
                page: getWindow() && getWindow().location.href,
                action: Constants.Telemetry.Action.EnsureAppDetailsData,
                actionModifier: Constants.Telemetry.ActionModifier.Error,
                details: JSON.stringify({
                    duration: Date.now() - start,
                    error: stringifyError(error)
                })
            };
            SharedInstrumentService.getProvider().probe('logTelemetryInfo', payload);
            if ((error === null || error === void 0 ? void 0 : (_error_error = error.error) === null || _error_error === void 0 ? void 0 : _error_error.code) === StatusCodes.NOT_FOUND) {
                logger.info(payload.details, {
                    action: payload.action,
                    actionModifier: payload.actionModifier
                });
            } else {
                logger.error(payload.details, {
                    action: payload.action,
                    actionModifier: payload.actionModifier
                });
            }
            dispatch(createSetEntityIdLoadingAction({
                entityType: Constants.EntityType.App,
                entityId: ''
            }));
            dispatch(createSetEntityIdFailedAction({
                entityType: Constants.EntityType.App,
                entityId
            }));
            throw error;
        });
    };
}
export function getServiceDetail(entityId) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const state = getState();
            const { flightCodes, isConverged } = state.config;
            try {
                let serviceDetailData$;
                if (__CLIENT__) {
                    serviceDetailData$ = entityRestClient.getService({
                        entityId,
                        isConverged,
                        flightCodes
                    });
                } else {
                    serviceDetailData$ = servicesDetailsViewService.getServiceDetailView({
                        entityId,
                        flightCodes,
                        isConverged,
                        request: mockRequest({
                            state: getState()
                        })
                    });
                }
                const serviceDetailData = yield serviceDetailData$;
                const dispatchActionAndResolve = ()=>{
                    dispatch(createEntityDetailsReceivedAction({
                        entityType: Constants.EntityType.Service,
                        entityDetails: serviceDetailData
                    }));
                    dispatch(createEntityDetailsReceivedAction({
                        entityType: Constants.EntityType.CloudsIndustry,
                        entityDetails: serviceDetailData
                    }));
                    return serviceDetailData;
                };
                dispatchActionAndResolve();
            } catch (error) {
                // we can recover from not getting app details, but for now I do not want to (no designed experience)
                // the below dispatch is to make sure
                dispatch(createEntityDetailsReceivedAction({
                    entityType: Constants.EntityType.Service,
                    entityDetails: null
                }));
                dispatch(createEntityDetailsReceivedAction({
                    entityType: Constants.EntityType.CloudsIndustry,
                    entityDetails: null
                }));
                throw error;
            }
        })();
    };
}
export function ensureServiceDetailsData(entityId) {
    return function(dispatch, getState) {
        if (!entityId) {
            return Promise.resolve(false);
        }
        entityId = entityId.toLowerCase();
        if (entityId === getState().services.entityIdLoading) {
            return Promise.resolve(false);
        }
        if (entityId === getState().services.entityIdFailed) {
            return Promise.resolve(false);
        }
        const promises = [];
        if (shouldEnsureServiceDetails(entityId, getState())) {
            promises.push(dispatch(getServiceDetail(entityId)));
        }
        if (shouldEnsureServiceRelatedApps(entityId, getState())) {
            promises.push(dispatch(getServiceRelatedAppsItems(entityId)));
        }
        if (!promises.length) {
            return Promise.resolve(false);
        }
        dispatch(createSetEntityIdFailedAction({
            entityType: Constants.EntityType.Service,
            entityId: ''
        }));
        dispatch(createSetEntityIdLoadingAction({
            entityType: Constants.EntityType.Service,
            entityId
        }));
        const start = Date.now();
        return Promise.all(promises).then(()=>{
            const payload = {
                page: getWindow() && getWindow().location.href,
                action: Constants.Telemetry.Action.EnsureServiceDetailsData,
                actionModifier: Constants.Telemetry.ActionModifier.End,
                details: JSON.stringify({
                    duration: Date.now() - start,
                    entityId
                })
            };
            logger.info(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
            dispatch(createSetEntityIdLoadingAction({
                entityType: Constants.EntityType.Service,
                entityId: ''
            }));
            return true;
        }).catch((error)=>{
            const payload = {
                page: getWindow() && getWindow().location.href,
                action: Constants.Telemetry.Action.EnsureServiceDetailsData,
                actionModifier: Constants.Telemetry.ActionModifier.Error,
                details: JSON.stringify({
                    duration: Date.now() - start,
                    error: stringifyError(error)
                })
            };
            logger.error(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
            dispatch(createSetEntityIdLoadingAction({
                entityType: Constants.EntityType.Service,
                entityId: ''
            }));
            dispatch(createSetEntityIdFailedAction({
                entityType: Constants.EntityType.Service,
                entityId
            }));
            throw error;
        });
    };
}
export function getUserProfile() {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            // user must be signed to get user profile and flag ProfileExp
            if (!getState().users.signedIn || !(getState().config.featureFlags.ProfileExp === 'true')) {
                return;
            }
            const payload = {
                page: getWindow().location.href,
                action: Constants.Telemetry.Action.getUserProfile,
                actionModifier: Constants.Telemetry.ActionModifier.Start,
                details: ''
            };
            logger.info(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
            dispatch(createUserProfileLoadingAction({
                isLoading: true
            }));
            try {
                const { serverBypass } = getState().config.featureFlags;
                const userProfile = yield userRestClient.getUserProfile(serverBypass);
                logger.info(payload.details, {
                    action: payload.action,
                    actionModifier: Constants.Telemetry.ActionModifier.End
                });
                dispatch(createUserProfileAction(userProfile));
            } catch (err) {
                const stringifiedError = stringifyError(err);
                logger.info(stringifiedError, {
                    action: payload.action,
                    actionModifier: Constants.Telemetry.ActionModifier.Error
                });
            } finally{
                dispatch(createUserProfileLoadingAction({
                    isLoading: false
                }));
            }
        })();
    };
}
export function getCustomers() {
    return function(dispatch, getState) {
        const user = getState().users;
        if (!user || !user.signedIn || user.isMSAUser) {
            return Promise.resolve();
        }
        const serverBypass = getState().config.featureFlags.serverBypass;
        return new Promise((resolve)=>{
            purchaseRestClient.getCustomers(serverBypass).then((customers)=>{
                dispatch(createSetCustomersAction(customers));
                if (customers && customers.length > 0) {
                    let selectedCustomer = customers.filter((x)=>x.type === CustomerType.Organization);
                    if (selectedCustomer.length === 0) {
                        selectedCustomer = customers.filter((x)=>x.type === CustomerType.Individual);
                    }
                    if (selectedCustomer && selectedCustomer.length > 0) {
                        dispatch(createSetActiveCustomerAction(selectedCustomer[0]));
                    }
                }
                resolve();
            }).catch((error)=>{
                logError('thunkActions.getCustomers', error);
            });
        });
    };
}
export function getUserTenantsDetails() {
    return function(dispatch, getState) {
        const state = getState();
        if (!getState().users.signedIn && !state.config.isEmbedded) {
            return Promise.resolve();
        }
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.GetTenantDetails,
            actionModifier: Constants.Telemetry.ActionModifier.Start,
            details: JSON.stringify({
                isSignedIn: state.users.signedIn,
                tid: state.users.tid
            })
        };
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
        dispatch(createUserTenantsDetailsLoadingAction({
            isLoading: true,
            hasError: false
        }));
        return userRestClient.getUserTenantsDetails().then(({ value })=>{
            const selectedTenant = value.find((tenant)=>state.users.tid === tenant.tenantId) || {
                tenantId: '',
                displayName: '',
                defaultDomain: '',
                countryCode: '',
                domains: [],
                id: '',
                tenantCategory: '',
                tenantType: '',
                azureSubscriptions: {}
            };
            dispatch(createUserTenantsDetailsAction(selectedTenant));
            dispatch(createUserTenantsDetailsLoadingAction({
                isLoading: false,
                hasError: false
            }));
            logger.info(payload.details, {
                action: payload.action,
                actionModifier: Constants.Telemetry.ActionModifier.End
            });
        }).catch((error)=>{
            dispatch(createUserTenantsDetailsLoadingAction({
                isLoading: false,
                hasError: true
            }));
            logger.error(JSON.stringify({
                isSignedIn: state.users.signedIn,
                tid: state.users.tid,
                error
            }), {
                action: payload.action,
                actionModifier: Constants.Telemetry.ActionModifier.Error
            });
        });
    };
}
export function getUserBillingAccounts() {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const state = getState();
            if (!state.users.signedIn && !state.config.isEmbedded) {
                return Promise.resolve();
            }
            const payload = {
                page: getWindow().location.href,
                action: Constants.Telemetry.Action.getUserBillingAccounts,
                actionModifier: Constants.Telemetry.ActionModifier.Start,
                details: JSON.stringify({
                    isSignedIn: state.users.signedIn,
                    tid: state.users.tid
                })
            };
            logger.info(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
            dispatch(createSetAccountIsLoadingAction({
                isLoading: true
            }));
            try {
                const billingAccounts = yield userRestClient.getUserBillingAccounts();
                const billingEAAccounts = billingAccounts.value.filter((account)=>{
                    const { properties: { agreementType, accountType } } = account;
                    return (agreementType === BillingAgreementType.EnterpriseAgreement || agreementType === BillingAgreementType.MicrosoftCustomerAgreement) && (accountType === BillingAccountType.Enterprise || accountType === BillingAccountType.Business);
                });
                dispatch(createSetAccountAction({
                    isLoading: false,
                    isEAAccount: !!billingEAAccounts.length,
                    accounts: billingAccounts.value,
                    hasError: false
                }));
                payload.details = JSON.stringify({
                    isSignedIn: state.users.signedIn,
                    tid: state.users.tid,
                    billingEAAccounts
                });
                logger.info(payload.details, {
                    action: payload.action,
                    actionModifier: Constants.Telemetry.ActionModifier.End
                });
            } catch (error) {
                createSetAccountAction({
                    isLoading: false,
                    isEAAccount: false,
                    accounts: null,
                    hasError: true
                });
                logger.error(JSON.stringify({
                    isSignedIn: state.users.signedIn,
                    tid: state.users.tid,
                    error: stringifyError(error)
                }), {
                    action: payload.action,
                    actionModifier: Constants.Telemetry.ActionModifier.Error
                });
            }
        })();
    };
}
export function getTenantType() {
    return function(dispatch, getState) {
        const user = getState().users;
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.GetTenantType,
            actionModifier: Constants.Telemetry.ActionModifier.Start,
            details: JSON.stringify({
                isSignedIn: user.signedIn,
                isMSAUser: user.isMSAUser
            })
        };
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
        if (!user.signedIn) {
            // if user is not signed in we cannot make this call
            return Promise.resolve();
        }
        if (user.isMSAUser) {
            dispatch(createSetTenantTypeAction(Constants.TenantType.Msa));
            return Promise.resolve();
        }
        // Prefetch the customer checkout page performance.
        dispatch(getCustomers());
        return new Promise((resolve)=>{
            const email = user.email;
            const payload = {
                page: getWindow().location.href,
                action: Constants.Telemetry.Action.GetTenantType,
                actionModifier: Constants.Telemetry.ActionModifier.Debug,
                details: JSON.stringify({
                    isSignedIn: user.signedIn,
                    isMSAUser: user.isMSAUser,
                    hasEmail: !!email
                })
            };
            logger.debug(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
        });
    };
}
export function checkAdminMemberships() {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            const state = getState();
            if (!state.users.signedIn || state.config.isEmbedded) {
                return Promise.resolve();
            }
            try {
                const adminMemberships = yield graphRestClient.checkAdminMemberShips();
                if (adminMemberships) {
                    dispatch(createUpdateUserRoleDefinitions(adminMemberships));
                }
                const payload = {
                    page: getWindow().location.href,
                    action: Constants.Telemetry.Action.GetUserTenantInfo,
                    actionModifier: Constants.Telemetry.ActionModifier.Info,
                    details: JSON.stringify({
                        adminType: adminMemberships
                    })
                };
                logger.info(payload.details, {
                    action: payload.action,
                    actionModifier: payload.actionModifier
                });
            } catch (error) {
                const payload = {
                    page: getWindow().location.href,
                    action: Constants.Telemetry.Action.GetUserTenantInfo,
                    actionModifier: Constants.Telemetry.ActionModifier.Error,
                    details: stringifyError(error)
                };
                logger.error(payload.details, {
                    action: payload.action,
                    actionModifier: payload.actionModifier
                });
            }
        })();
    };
}
export function updateUser({ userDetails }) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            HttpModule.updateAccessToken(userDetails.accessToken);
            dispatch(createUserLoginDetailsAction(userDetails));
            // dispatch finished loading
            dispatch(createUserSignInFetchStatusAction({
                loading: false
            }));
            // update user data
            dispatch(getUserProfile());
            dispatch(fetchUserFavourites());
            dispatch(checkAdminMemberships());
            if (getState().config.isAppSource && !getState().config.isEmbedded) {
                dispatch(getUserTenantsDetails());
                dispatch(getTenantType());
                dispatch(getUserBillingAccounts());
            }
        })();
    };
}
export function updateUserProfile(data) {
    return function(dispatch) {
        return Promise.resolve().then(()=>{
            dispatch(createUpdateUserProfileAction(data));
            return Promise.resolve();
        })// eslint-disable-next-line node/handle-callback-err
        .catch(()=>{
            return Promise.resolve();
        });
    };
}
export function getDynamicCampaign(request) {
    return function(dispatch) {
        return new Promise((resolve, reject)=>{
            const dispatchActionAndResolve = (campaignData)=>{
                dispatch(createDynamicCampaignReceivedAction({
                    campaignInfo: campaignData
                }));
                resolve();
            };
            dynamicCampaignRestClient.getDynamicCampaign(request).then((campaignHtml)=>{
                dispatchActionAndResolve({
                    html: campaignHtml
                });
            }).catch((error)=>{
                if (error.status !== 404) {
                    // dispatch a received campaign action with no campaign info (null)
                    dispatchActionAndResolve(null);
                }
                reject(error);
            });
        });
    };
}
export function createCustomer() {
    return function(dispatch, getState) {
        dispatch(createClearErrorAction());
        const customers = getState().checkout.customers;
        if (customers && customers.length > 0) {
            // check to see if we already have a customer, if so, don't create it
            return Promise.resolve();
        }
        return new Promise((resolve, reject)=>{
            // new customer that's not bootstrapped, create the customer
            let firstName = getState().users.firstName;
            let lastName = getState().users.lastName;
            const displayName = getState().users.displayName;
            // firstname/lastname are required, so check if we have them otherwise work around the issue
            if (!firstName && !lastName && displayName) {
                firstName = displayName;
                lastName = '-';
            } else if (!firstName) {
                firstName = '-';
                lastName = '-';
            } else if (!lastName) {
                lastName = '-';
            }
            const newCustomer = {
                type: CustomerType.Individual,
                address: {
                    firstName,
                    lastName,
                    country: getState().config.billingCountryCode.toUpperCase()
                }
            };
            purchaseRestClient.createCustomer(newCustomer).then((response)=>{
                // create response does not include the address, so we need to update that ourselves
                const customer = _object_spread_props(_object_spread({}, response), {
                    address: newCustomer.address
                });
                dispatch(createSetActiveCustomerAction(customer));
                resolve();
            }).catch((error)=>{
                dispatch(createErrorAction());
                reject(error);
            });
        });
    };
}
export function updateCustomer(address) {
    return function(dispatch) {
        return new Promise((resolve)=>{
            purchaseRestClient.updateCustomer(address).then(()=>{
                dispatch(createUpdateCustomerAction(address));
                resolve();
            }).catch((error)=>{
                logError('thunkActions.updateCustomer', error);
            });
        });
    };
}
export function generatePublisherOffer(subscriptionId) {
    return function(dispatch) {
        return new Promise((resolve, reject)=>{
            purchaseRestClient.getPublisherOfferInfo(subscriptionId).then((response)=>{
                dispatch(createSetPublisherTokenResponse(response));
                resolve();
            }).catch((error)=>{
                dispatch(createSetPublisherTokenResponse({}));
                reject(error);
            });
        });
    };
}
export function preWarmAccount(addTestHeader) {
    return function(_, getState) {
        const { config: { commerceApiHost } } = getState();
        try {
            commerceApiRestClient.preWarmAccount({
                commerceApiHost,
                addTestHeader
            });
        } catch (ex) {}
    };
}
export function updatePurchaseStatus() {
    return (dispatch, getState)=>{
        const reviewsData = getState().apps.appReviewsData;
        dispatch(createGetAppReviewsAction(_object_spread_props(_object_spread({}, reviewsData), {
            isPurchased: true
        })));
    };
}
export function setStorefrontName(storefrontName) {
    return (dispatch)=>{
        dispatch(createSetStorefrontNameAction(storefrontName));
    };
}
export function ensureCheckoutApp({ entityId }) {
    return function(dispatch, getState) {
        return _async_to_generator(function*() {
            try {
                return yield Promise.all([
                    dispatch(getAppDetail(entityId, false)),
                    dispatch(getAppPricing(entityId))
                ]);
            } catch (error) {
                const servicePromises = yield dispatch(ensureServiceDetailsData(entityId));
                const state = getState();
                const targetApp = state.services.dataList.find((offer)=>(offer === null || offer === void 0 ? void 0 : offer.entityId.toString().toLowerCase()) === entityId.toString().toLowerCase());
                if (targetApp === null || targetApp === void 0 ? void 0 : targetApp.isHiddenPrivateOffer) {
                    return servicePromises;
                }
                throw error;
            }
        })();
    };
}
export function getProductDetail(entityId, configState) {
    return _async_to_generator(function*() {
        const { flightCodes, isConverged } = configState;
        let productDetailData$;
        if (__CLIENT__) {
            productDetailData$ = entityRestClient.getProduct({
                entityId,
                isConverged,
                flightCodes
            });
        } else {
            productDetailData$ = productDetailsViewService.getProductDetailView({
                entityId,
                flightCodes,
                isConverged,
                request: mockRequest({
                    state: {
                        config: configState
                    }
                })
            });
        }
        const productDetailData = yield productDetailData$;
        return productDetailData;
    })();
}
